import React from 'react';

import './style.css';

const Clearfix = () => <div className="clearfix" />;

export default Clearfix;
